/** @jsxImportSource theme-ui */
import { useSelector } from "react-redux";

import { selectUIVersion } from "store/app";
import { SelectedValuesBar, StageBar } from "components";

export default function FooterSelector({ displayReviewModal }) {
  const UIVersion = useSelector(selectUIVersion);

  switch (UIVersion) {
    // StageBar is for Goalie Gear footer
    case 2:
      return <StageBar />;

    default:
      return <SelectedValuesBar displayReviewModal={displayReviewModal} />;
  }
}
